import * as React from 'react';
import styled from '@emotion/styled';
import { Loader } from 'semantic-ui-react';

const ButtonBaseStyles = styled.button<{ width?: string }>`
  align-items: center;
  border-radius: 1px;
  display: flex;
  /* font-weight: 600; */
  justify-content: center;
  transition: all 0.2s;
  background-color: #444340;
  width: ${props => props.width ? props.width : '122px'};
  height: 32px;
  color: white;
  cursor: pointer;
  border-style: none;
  border-radius:5px;
  :hover {
    background-color: #33322f;
    color: #fff;
    svg{
      path{
        stroke: #fff;
      }
      circle{
        stroke:#fff;
      }
    }
  }
  svg{
    margin-right:8px;
  }
`;
const ButtonPrimaryMedium = styled(ButtonBaseStyles)`
  height: 40px;
  width: ${props => props.width ? props.width : '138px'};
`;
const ButtonPrimaryTwoSmall = styled(ButtonBaseStyles)`
  background-color: #BCC2C7;
  height: 32px;
  width: ${props => props.width ? props.width : '122px'};
  color:#444340;
  :hover{
    background-color: #E2E2E2;
    color:#444340;
  }
`;
const ButtonPrimaryTwoMedium = styled(ButtonBaseStyles)`
  background-color: #BCC2C7;
  height: 40px;
  width: ${props => props.width ? props.width : '138px'};
  color:#444340;
  :hover{
    background-color: #E2E2E2;
    color:#444340;
  }
`;
const ButtonPrimaryTwoLarge = styled(ButtonBaseStyles)`
  background-color: #BCCBD5;
  width: ${props => props.width ? props.width : '304px'};
  height: 64px;
  text-transform: uppercase;
  color:#444340;
  font-weight: 600;
  font-size: 16px;
  border-radius: 0;
  :hover{
    background-color: #D0D9DF;
    color:#444340;
  }
`;
const ButtonPrimaryTwoLargeDisabled = styled(ButtonPrimaryTwoLarge)`
  background-color: #EAE8E5;
  cursor: not-allowed;
  color:#CCC9C6;
  :hover{
    background-color: #EAE8E5;
    color:#CCC9C6;
  }
`;
const ButtonSecondarySmall = styled(ButtonBaseStyles)`
  border: 1px solid #eae8e5;
  width: ${props => props.width ? props.width : '122px'};
  height: 32px;
  background-color: white;
  color: #444340;
`;
const ButtonSecondarySmallDisabled = styled(ButtonSecondarySmall)`
  background-color: #EAE8E5;
  cursor: not-allowed;
  color:#CCC9C6;
  :hover{
    background-color: #EAE8E5;
    color:#CCC9C6;
  }
`;
const ButtonSecondaryMedium = styled(ButtonBaseStyles)`
  border: 1px solid #eae8e5;
  width: ${props => props.width ? props.width : '138px'};
  height: 40px;
  background-color: white;
  color: #444340;
`;
const ButtonSecondaryMediumDisabled = styled(ButtonSecondaryMedium)`
  background-color: #EAE8E5;
  cursor: not-allowed;
  color:#CCC9C6;
  :hover{
    background-color: #EAE8E5;
    color:#CCC9C6;
  }
`;
const ButtonTertiarySmall = styled(ButtonBaseStyles)`
  border: 1.2px solid #33322f;
  width: ${props => props.width ? props.width : '122px'};
  height: 32px;
  background-color: white;
  color: #444340;
`;
const ButtonTertiaryMedium = styled(ButtonBaseStyles)`
  border: 1.2px solid #33322f;
  width: ${props => props.width ? props.width : '138px'};
  height: 40px;
  background-color: white;
  color: #444340;
`;

const ButtonGreenSmall = styled(ButtonBaseStyles)`
  width: ${props => props.width ? props.width : '138px'};
  height: 40px;
  background-color: #79A666;
  color: white;
  :hover{
    background-color: #5b814b;
  }
`;

interface Props {
  buttonText: string;
  width?: string;
  buttonType?:
    | 'ButtonPrimaryMedium'
    | 'ButtonPrimaryTwoSmall'
    | 'ButtonPrimaryTwoMedium'
    | 'ButtonPrimaryTwoLarge'
    | 'ButtonPrimaryTwoLargeDisabled'
    | 'ButtonSecondarySmall'
    | 'ButtonSecondaryMedium'
    | 'ButtonSecondaryMediumDisabled'
    | 'ButtonTertiarySmall'
    | 'ButtonTertiaryMedium'
    | 'ButtonGreenSmall';
  [key: string]: any;
  loadingStatus?: boolean;
  icon?: string;
}
const Button = (props: Props | any) => {
  const GetButton = () => {
    switch (props.buttonType) {
      case 'ButtonPrimaryMedium':
        return <ButtonPrimaryMedium {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonPrimaryMedium>;
      case 'ButtonPrimaryTwoSmall':
        return (
          <ButtonPrimaryTwoSmall {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonPrimaryTwoSmall>
        );
      case 'ButtonPrimaryTwoMedium':
        return (
          <ButtonPrimaryTwoMedium {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonPrimaryTwoMedium>
        );
      case 'ButtonPrimaryTwoLarge':
        return (
          <ButtonPrimaryTwoLarge {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonPrimaryTwoLarge>
        );
        case 'ButtonPrimaryTwoLargeDisabled':
        return (
          <ButtonPrimaryTwoLargeDisabled {...props} disabled>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonPrimaryTwoLargeDisabled>
        );
      case 'ButtonSecondarySmall':
        return <ButtonSecondarySmall {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonSecondarySmall>;
        case 'ButtonSecondarySmallDisabled':
        return <ButtonSecondarySmallDisabled {...props} disabled>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonSecondarySmallDisabled>;
      case 'ButtonSecondaryMedium':
        return (
          <ButtonSecondaryMedium {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonSecondaryMedium>
        );
        case 'ButtonSecondaryMediumDisabled':
        return (
          <ButtonSecondaryMediumDisabled {...props} disabled>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonSecondaryMediumDisabled>
        );
      case 'ButtonTertiarySmall':
        return <ButtonTertiarySmall {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonTertiarySmall>;
      case 'ButtonTertiaryMedium':
        return <ButtonTertiaryMedium {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonTertiaryMedium>;
      case 'ButtonGreenSmall':
        return <ButtonGreenSmall {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonGreenSmall>;
      default:
        return <ButtonBaseStyles {...props}>{props.icon}{props.loadingStatus ? <Loader inline size="small" active /> : props.buttonText}</ButtonBaseStyles>;
    }
  };
  return GetButton();
};

export default Button;
